import { render, staticRenderFns } from "./assignmentEdit.vue?vue&type=template&id=b7485660"
import script from "../../controllers/assignment/assignment-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/assignment/assignment-edit.js?vue&type=script&lang=js&external"
import style0 from "./assignmentEdit.vue?vue&type=style&index=0&id=b7485660&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports